/**
 * The parent visual component for displaying the list of selected monitoring sites and their
 * sampling frequencies. This component is responsible for interactions between the underlying
 * components that display the list, and the rest of the system.
 */

import SelectedSitesPanelFooterComponent from './component-footer';

const HEADER_CLASS = 'aims_msp_selected-sites-panel_header';
const BODY_CLASS = 'aims_msp_selected-sites-panel_body';
const FOOTER_CLASS = 'aims_msp_selected-sites-panel_footer';
const TEMPLATE = `
    <div class='container ${HEADER_CLASS}'>
        <div class='row'>
            <div class='col-12 msp-selections-col-site-id'>
                id
            </div>
        </div>
    </div>
    
    <div class='container ${BODY_CLASS}'>
    </div>

    <div class='container ${FOOTER_CLASS}'>
    </div>
  </div>
`;

export default class SelectedSitesPanelComponent {

  constructor($parent, datasetsModel, selectedSitesModel, referenceSitesHashModel, algorithmsModel,
              variablesModel, siteDistanceModel, downloadListDialogLauncher, downloadCsvDialogLauncher) {

    // Cache references.
    this._$parent = $parent;
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;

    // Insert the template to render the list.
    this._$parent.html(TEMPLATE);

    // Capture the reference to the tbody for use when inserting rows.
    this._$body = this._$parent.find(`.${BODY_CLASS}`);

    // Render the footer.
    new SelectedSitesPanelFooterComponent(
      this._$parent.find(`.${FOOTER_CLASS}`),
      datasetsModel,
      selectedSitesModel,
      referenceSitesHashModel,
      algorithmsModel,
      variablesModel,
      siteDistanceModel,
      () => {
        downloadListDialogLauncher.launch();
      },
      () => {
        downloadCsvDialogLauncher.launch();
      }
    );

    // Declare an internal map for rendering a selected item.
    this._listItemMap = {};

    // Declare the internal model, mapping a reef to a sampling frequency.
    this._internalModel = [];

    // Register for events.
    this._selectedSitesModel.on(this._selectedSitesModel.EVENT_DATA_CHANGED, this._handleChange.bind(this));

  }

  /**
   * Event handler invoked when the map selection model changes to update the rendered display.
   */
  _handleChange() {

    // Loop through the selections, adding/remove from the internal model as we go.
    let _newListItemMap = [];
    const siteSelectionsData = this._selectedSitesModel.getData();
    const referenceSitesData = this._referenceSitesHashModel.getData();
    const sortedKeys = Object.keys(siteSelectionsData);
    sortedKeys.sort();
    sortedKeys.forEach((id) => {
      const referenceSite = referenceSitesData[id];

      // Has this site been rendered previously?
      let listItem = this._listItemMap[id];
      if (listItem) {

        // Previously rendered, so remove from cached list so it isn't cleaned up later, and
        // re-render at bottom of list by detaching and re-appending.
        listItem.el.detach().appendTo(this._$body);
        delete this._listItemMap[id];

      } else {

        // Not previously rendered, so render and instantiate the listItem.
        this._$body.append(`
            <div class='row' aria-id='${id}'>
                <div class='col-12 msp-selections-col-site-id'>
                    ${referenceSite.name || id}
                </div>
            </div>
        `);
        const _$elItem = this._$body.find(`div[aria-id='${id}']`);
        listItem = {
          site: referenceSite,
          el: _$elItem
        };

      }
      _newListItemMap[id] = listItem;
    });

    // Clean up any previously rendered list items that were not selected.
    Object.keys(this._listItemMap).forEach((id) => {
      if (!_newListItemMap[id]) {
        this._listItemMap[id].el.remove();
      }
    });

    // Use the new list of items.
    this._listItemMap = _newListItemMap;

  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/component.js